<template>
  
  <div>

    <div class="my-7 flex justify-center align-middle content-center items-center cursor-pointer w-full">
      <router-link to="/"><img src="../assets/images/medremindLogoNew.png" alt="logo" class=" mx-auto md:mr-3  w-3/6 md:w-full sm:h-8"></router-link>
    </div>

    <div>
      <h1  class="text-black text-2xl font-medium font-outfit my-2"  > Sign up for free to start using MedRemind</h1>
    </div>

    

    <div class="bg-white text-black px-2 md:px-20 py-8 font-outfit flex flex-col justify-center mx-auto align-middle    content-center md:w-2/4">

        <!-- <div class=" bg-gray-200 rounded-full mb-2 mx-12 ">
                <div
                  class=" p-1 text-xs font-medium leading-none text-center text-blue-100 bg-blue-600 w-56
                    rounded-full">
                  Step1
                </div>
        </div> -->

        

        <form @submit.prevent="handleNextPage">
          <div v-if="formOneVisible">

            <div class=" text-Black text-xl mx-11 rounded-md bg-gray-100" >
                <h1 class="py-2 ">Company Details</h1>
            </div>

            <div class="flex flex-col text-start mx-11 mt-10 mb-1">
                <label class="font-semibold text-sm mb-2" for="">What is your company's name?</label>
                <input v-model="companyName"  type="text" required class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter company's name " >
            </div>

            <div class="flex flex-col text-start mx-11 mt-5 mb-2">
                <label class="font-semibold text-sm mb-2" for="">Company's Registration number</label>
                <input v-model="cacRegNO" required type="text"  class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter CAC reg number " >
            </div>

            <div class="flex flex-col text-start mx-11 mt-5 mb-2">
                <label class="font-semibold text-sm mb-2" for="">Company Type</label>
                <select v-model="companyType" required class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Select type " >
                <option selected value="PHARMACY">Pharmacy</option>
                <option value="HOSPITAL">Hospital</option>
                </select>
            </div>

            <div class="flex flex-col text-start mx-11 mt-5 mb-2">
                <label class="font-semibold text-sm mb-2"  for="">What is your company's physical address?</label>
                <input v-model="companyAddress" type="text" required class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter company's address " >
            </div>

            <div class="flex flex-col text-start mx-11 mt-5">
                <label class="font-semibold text-sm mb-2" for="">City</label>
                <input v-model="city" type="text" required class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter city " >
            </div>
            
            <div class="flex justify-between ml-11 md:ml-0">
              <div class="flex flex-col text-start md:mx-11 mt-5 mb-2 w-32 md:w-64">
                  <label class="font-semibold text-sm mb-2" for="country">Country</label>
                  <select v-model="country" required  class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                  bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" >
                  <option selected value="Nigeria">Nigeria</option>
                  </select>
              </div>

              <div class="flex flex-col text-start mr-11 md:mr-11 md:mx-11 mt-5 mb-2 w-32 md:w-64">
                  <label class="font-semibold text-sm mb-2" for="states">State</label>
                  <select v-model="state" id="states" required  class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"  >
                  <option selected disabled>Choose a state</option>
                  <option value="Abuja(FCT)">Abuja(FCT)</option>
                  <option value="Adamawa">Adamawa</option>
                  <option value="Akwa Ibom">Akwa Ibom</option>
                  <option value="Anambra">Anambra</option>
                  <option value="Bauchi">Bauchi</option>
                  <option value="Abia">Abia</option>
                  <option value="Bayelsa">Bayelsa</option>
                  <option value="Benue">Benue</option>
                  <option value="Borno">Borno</option>
                  <option value="Cross River">Cross River</option>
                  <option value="Delta">Delta</option>
                  <option value="Ebonyi">Ebonyi</option>
                  <option value="Edo">Edo</option>
                  <option value="Ekiti">Ekiti</option>
                  <option value="Enugu">Enugu</option>
                  <option value="Gombe">Gombe</option>
                  <option value="Imo">Imo</option>
                  <option value="Jigawa">Jigawa</option>
                  <option value="Kaduna">Kaduna</option>
                  <option value="Kano">Kano</option>
                  <option value="Katsina">Katsina</option>
                  <option value="Kebbi">Kebbi</option>
                  <option value="Kogi">Kogi</option>
                  <option value="Kwara">Kwara</option>
                  <option value="Lagos">Lagos</option>
                  <option value="Nasarawa">Nasarawa</option>
                  <option value="Niger">Niger</option>
                  <option value="Ogun">Ogun</option>
                  <option value="Ondo">Ondo</option>
                  <option value="Osun">Osun</option>
                  <option value="Oyo">Oyo</option>
                  <option value="Plateau">Plateau</option>
                  <option value="Rivers">Rivers</option>
                  <option value="Sokoto">Sokoto</option>
                  <option value="Taraba">Taraba</option>
                  <option value="Yobe">Yobe</option>
                  <option value="Zamfara">Zamfara</option>
                  </select>
              </div>
            </div>

            

            <div class="mt-8 mx-11">
                <button  type="submit" class="text-white bg-medalertBlue hover:bg-blueHover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-lg w-full py-3 text-center mr-3 md:mr-0 dark: dark:hover:bg-blueHover dark:focus:ring-purple font-outfit">Continue</button>
            </div>

            <!-- <div class="mt-6 flex justify-end mr-12">
                <button type="submit" class="text-white bg-medalertBlue hover:bg-purple focus:ring-4 focus:outline-none focus:ring-blue-300 font-normal rounded text-lg w-36 py-3 text-center mr-3 md:mr-0 dark:bg-purple dark:hover:bg-purple dark:focus:ring-purple font-outfit">Next</button>
            </div> -->
          </div>

        </form>

        <form action="" @submit.prevent="handleSubmit">
          <div v-if="formTwoVisible">
            <div class=" text-Black text-xl mx-11 rounded-md bg-gray-100" >
                <h1 class="py-2 ">Personal Details</h1>
            </div>

            <div
              v-if="error"
              class=" border mx-11 bg-red  text-white px-4 py-3 mt-4 rounded relative"
              role="alert">

              <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
              <span class="">{{ error }}</span>
            </div>

             <div class="flex justify-between ml-11 md:ml-11 md:mx-auto">
                
                <div class="flex flex-col text-start  mt-5 mb-2 w-32 md:w-5/12">
                    <label class="font-semibold text-sm mb-2" for="">First name</label>
                    <input v-model="firstName" type="text" required  class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                    bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter first name " >
                </div>

                 <div class="flex flex-col text-start mr-11 mt-5 mb-2 w-32 md:w-5/12">
                    <label class="font-semibold text-sm mb-2" for="">Last name</label>
                    <input v-model="lastName" required type="text"  class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                    bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter last name " >
                </div>

             </div>

             <div class="flex flex-col text-start mx-11 mt-5 mb-2">
                <label class="font-semibold text-sm mb-2" for="">Phone number</label>
                <input v-model="phoneNo" type="number" required class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter your phone no " >
             </div>

            <div class="flex flex-col text-start mx-11 mt-5 mb-2">
                <label class="font-semibold text-sm mb-2" for="">Email</label>
                <input v-model="email" type="text" required class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter your email " >
            </div>

            <div class="flex flex-col text-start mx-11 mt-5 mb-2">
              <div class="flex justify-between">
                  <label class="font-semibold text-sm mb-2" for="">Password</label>
                  <div class="cursor-pointer text-xs font-semibold font-outfit">
                    <span  @click="showPassword = !showPassword">  <p v-if="showPassword"> HIDE </p> <p v-else>SHOW</p> </span>
                  </div>
              </div>
                <input v-model="password" v-bind:type="[showPassword ? 'text' : 'password']" type="text" required class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter your password " >
            </div>

            <div class="flex justify-between">
              <div class="mt-8 mx-11 w-52">
                  <button @click="handlePreviousPage" class="text-white bg-gray-400 hover:bg-medalertOrange focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-lg w-full py-3 text-center mr-3 md:mr-0 dark: dark:hover:bg-medalertOrange dark:focus:ring-purple font-outfit">Back</button>
              </div>

              <div class="mt-8 mx-11 w-52">
                  <button 
                        :disabled="inactive"
                        :class="inactive ? 'cursor-not-allowed' : ''" type="submit"  class="text-white bg-medalertBlue disabled:bg-gray-200 hover:bg-blueHover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-lg w-full py-3 text-center mr-3 md:mr-0 dark: dark:hover:bg-blueHover dark:focus:ring-purple font-outfit">Sign up
                      <!-- <span v-if="isLoading">
                          <Loading />
                      </span> -->
                  </button>
              </div>
            </div>

            
          </div>
          
          <!-- <div class="text-red text-xl mx-10 mb-2 mt-5 text-1xl" >{{error}}</div> -->

        </form>

        <div class="mt-5 text-center flex justify-start mx-auto">
                <p class="text-base">
                  Already have account?
                   <router-link to="/login" ><span class="text-blue-600 hover:underline">
                    Login</span
                  ></router-link>
                </p>
        </div>

    </div>

  </div>

</template>



<script>

import { ref } from 'vue'
import {useStore} from 'vuex'
import {useRouter} from 'vue-router'
import Loading from "../components/Loading";

export default {

  components:{Loading},
   

    setup() {

    const isLoading = ref(false);
    const formOneVisible = ref(true)
    const formTwoVisible = ref(false)

    const showPassword = ref(false)

    const companyName = ref('')
    const cacRegNO = ref('')
    const companyType = ref('')
    const companyAddress = ref('')
    const city =ref('')
    const state = ref('');
    const country = ref("")

    const firstName =ref('')
    const lastName =ref('')
    const phoneNo =ref('')
    const email =ref('')
    const password =ref('')

    


    const error =ref(null)
    

    const store = useStore()
    const router = useRouter()
    const inactive = ref(false);

    const handleNextPage = () =>{
        formOneVisible.value = false
        formTwoVisible.value = true
    }


    const handlePreviousPage = () =>{
      formOneVisible.value = true
      formTwoVisible.value = false
    }

    const handleSubmit = async () => {
      try {  
        // isLoading.value = true;
        inactive.value = true
        await store.dispatch('createClient', {companyName: companyName.value, cacRegNO: cacRegNO.value, companyType:companyType.value, companyAddress: companyAddress.value, city: city.value, state: state.value, country: country.value, firstName: firstName.value, lastName: lastName.value, phoneNo: phoneNo.value, email: email.value, password: password.value})
      
        // isLoading.value = false;
        inactive.value = false

        alert('Your account have been created successfully. You will be contacted to verify your account within 12 hours. Login now')
        router.push('/login')
      } catch(err) {
        // isLoading.value = false;
        inactive.value = false
        error.value = err.response.data.result.message
        console.log(error.value)
        setTimeout(() => {
          error.value = "";
          }, 3000);
        }
    }
    
    return {
      formOneVisible, 
      handleSubmit,
      formTwoVisible,
      companyName, 
      cacRegNO, 
      companyType, 
      companyAddress, 
      city, 
      state, 
      country, 
      firstName, 
      lastName, 
      phoneNo, 
      email, 
      password,
      error,
      isLoading,
      inactive,
      showPassword,
      // err,
      handleNextPage,
      handlePreviousPage
    }

  }

}


</script>



<style>

</style>